import React, { useState } from "react";
import { Box, Card, CardContent, Typography, Button, Grid, Divider, Link, keyframes, styled } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { motion } from "framer-motion";
import AutoPopUp from "./AutoPopUp";

const categories = [
    {
        title: "Engineering",
        links: [
            "JEE Main 2025 Answer Key & Solutions",
            "WBJEE-2024 Answer & Solution",
        ],
    },

    {
        title: "Medical",
        links: [
            "NEET Answer Key & Solutions 2024 for All Codes",
            "NEET 2024 Answer Key & Solutions: Code - Q, R, S, T",
        ],
    },

    {
        title: "Olympiads & Boards",
        links: [
            "INOs 2025 Answer Key and Solutions",
            "CBSE - VIII Studying (01-12-2024)",
        ],
    },
];

const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

const PopularCourses = () => {

    const [openPopup, setOpenPopup] = useState(false);

    const handleClosePopup = () => {
        setOpenPopup(false);
    };

    const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

    // Styled animated container
    const AnimatedBox = styled(Box)(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: theme.spacing(5, 2),
        textAlign: "center",
        animation: `${fadeInUp} 1s ease-out`,
    }));

    // Styled phone number link
    const PhoneLink = styled(Link)(({ theme }) => ({
        color: theme.palette.primary.main,
        fontWeight: "bold",
        fontSize: "1.1rem",
        marginLeft: 4,
        textDecoration: "none",
        transition: "color 0.3s ease",

        "&:hover": {
            color: theme.palette.secondary.main,
            textDecoration: "underline",
            cursor: "pointer",
        },
    }));

    const StyledText = styled(Typography)(({ theme }) => ({
        fontFamily: `'Poppins', sans-serif`,
        fontWeight: 600,
        fontSize: "1.25rem",
        letterSpacing: "0.5px",
        color: "#333",
    }));



    return (
        <Box sx={{ p: { xs: 3, md: 6 }, backgroundColor: "#e0f5fe" }}>
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
            >
                <Typography variant="h5" align="center" fontWeight={700} gutterBottom>
                    Official Answer Keys & Solutions
                </Typography>
            </motion.div>
            <Grid container spacing={2} justifyContent="center" sx={{ mt: 1 }}>
                {categories.map((category, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <motion.div initial="hidden" whileInView="visible" variants={cardVariants} viewport={{ once: true }}>
                            <Card
                                sx={{
                                    borderRadius: 3,
                                    boxShadow: 4,
                                    overflow: "hidden",
                                    transition: "transform 0.3s ease-in-out",
                                    "&:hover": { transform: "scale(1.05)" },
                                }}
                            >
                                <Box sx={{ backgroundColor: "#00aeef", p: 2, color: "white", textAlign: "center" }}>
                                    <Typography variant="h6" fontWeight={600} sx={{ fontSize: { xs: "1rem", md: "1.2rem" } }}>
                                        {category.title}
                                    </Typography>
                                </Box>
                                <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                                    {category.links.map((link, idx) => (
                                        <Box
                                            key={idx}
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="space-between"
                                            mb={1.5}
                                            flexDirection={{ xs: "column", sm: "row" }}
                                            textAlign={{ xs: "center", sm: "left" }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    color: "#333",
                                                    fontWeight: 500,
                                                    fontSize: { xs: "0.85rem", md: "1rem" },
                                                }}
                                            >
                                                <Box component="span" sx={{ color: "#0077b6", fontSize: "1.2rem", mr: 1 }}>•</Box>
                                                {link}
                                            </Typography>
                                            <Button
                                                variant="contained"
                                                sx={{
                                                    backgroundColor: "#e3f2fd",
                                                    color: "#0077b6",
                                                    borderRadius: "20px",
                                                    textTransform: "none",
                                                    fontWeight: 600,
                                                    fontSize: { xs: "10px", md: "11px" },
                                                    boxShadow: "none",
                                                    transition: "0.3s",
                                                    mt: { xs: 1, sm: 0 },
                                                    "&:hover": { backgroundColor: "#bbdefb" },
                                                }}
                                                startIcon={<FileDownloadIcon sx={{ color: "#0077b6" }} />}
                                                onClick={() => setOpenPopup(true)}
                                            >
                                                Download
                                            </Button>
                                        </Box>
                                    ))}
                                </CardContent>
                                <Divider />
                                <Box sx={{ textAlign: "center", pb: 3, pt: 2 }}>
                                    <Typography
                                        component={motion.div}
                                        whileHover={{ scale: 1.1 }}
                                        color="#0077b6"
                                        sx={{ cursor: "pointer", fontWeight: 600, textDecoration: "underline", fontSize: { xs: "0.9rem", md: "1rem" } }}
                                    >
                                        See all answers/ solutions
                                    </Typography>
                                </Box>
                            </Card>
                        </motion.div>
                    </Grid>
                ))}
            </Grid>
            <AnimatedBox>
                <StyledText>
                    For more information, contact this number:
                    <PhoneLink href="tel:7026505152">7026505152</PhoneLink>
                </StyledText>
            </AnimatedBox>
            <AutoPopUp isOpen={openPopup} onClose={handleClosePopup} />
        </Box>
    );
};

export default PopularCourses;